import { useMemo } from 'react';
import Title from '@/components/Title/Title';

type headers = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'span';

interface IGetHeadingLevel {
  mainLevel: string;
  currentLevel: number;
  children: any;
  styles?: string;
  asClass?: boolean;
}

export function GetHeadingLevel({ mainLevel, currentLevel, children, styles, asClass = false }: IGetHeadingLevel) {
  const { heading, style } = useMemo(() => {
    const level = `h${Number(mainLevel.charAt(1)) + currentLevel}`.toString();
    return {
      heading: asClass ? 'span' : level,
      style: asClass ? `${styles} ${level}` : styles,
    };
  }, [mainLevel, currentLevel, asClass, styles]);

  return (
    <Title component={heading as headers} className={style}>
      {children}
    </Title>
  );
}
